import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { LocalizationPipe } from '@abp/ng.core';

@Component({
  selector: 'app-ivr-instance-toolbar',
  standalone: true,
  imports: [CommonModule, LocalizationPipe],
  templateUrl: './ivr-instance-toolbar.component.html',
})
export class IvrInstanceToolbarComponent {
  @Output() add = new EventEmitter<void>();
}
